<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="projectsService"
    [idKey]="'checklistId'"
    [subSectionSettings]="'deleteSettingsChecklist'"
></base-index-page>